module.exports = __webpack_public_path__ + "static/img/consequences.c2c32390.png";